export default __webpack_public_path__ + "static/gopi-28ceba7df92fe275cbf9f4dbff034221.svg";